import { InvoicingPaths } from "@invoicing/types";
import { BankingPaths } from "@banks/types/enums";
import { CashRegisterPaths } from "@cash-register/types/enums";
import { DmsPaths } from "@domain/routing/dmsPaths";

export enum ModuleSubGroups {
    ER = "rechnungen",
    ErA = "anzahlungen",
    Default = "default",
}

export enum AppRoutes {
    home = "/home",
    manageCompanies = "/companies",
    adminVatNumbers = "/adminVatNumbers",
    adminMetroAccountingCategories = "/adminMetroAccountingCategories",
    adminMetroArticles = "/adminMetroArticles",
    profile = "/profile",
    releaseNotes = "/release-notes",
    agb = "/agb",
    impressum = "/impressum",
    datenschutz = "/datenschutz",
    haftungsausschluss = "/haftungsausschluss",
    cookies = "/cookies",
    avv = "/avv",
    datevCallback = "/datevOpenId/callback",
    m365Callback = "/m365/callback",
    viewer = "/viewer",

    // auth
    authView = "/auth-actions",
    authLogin = "/login",
    authPasswordReset = "/reset",
    authNewPassword = "/new-password",
    authRegister = "/register",
    authVerifyEmail = "/verify-email",

    // { OCR } pdf - tool
    ocr = "/pdf-tool",

    // { ER } purchase invoices
    invoice = "/eingangsrechnungen",
    invoiceModule = "/eingangsrechnungen/:subGroup",
    invoiceAnalysisOpos = "/eingangsrechnungen/:subGroup/auswertung/opos",
    invoiceAnalysisAvis = "/eingangsrechnungen/:subGroup/auswertung/avis",
    invoiceAnalysisFalligkeit = "/eingangsrechnungen/:subGroup/auswertung/falligkeit",
    invoiceFestschreibung = "/eingangsrechnungen/:subGroup/festschreibung",
    invoiceTemplates = "/eingangsrechnungen/:subGroup/templates",

    // { Deb } debitors
    debitor = "/debitors",
    debitorAnalysisOpos = "/debitors/auswertung/opos",
    debitorAnalysisAvis = "/debitors/auswertung/avis",
    debitorTemplates = "/debitors/templates",

    // { KB } kassenbuch
    kassenbuch = "/kassenbuch",
    kassenbuchManage = "/kassenbuch/kassenbucher",
    kassenbuchOverview = "/kassenbuch/overview/:uuid",
    kassenbuchTemplates = "/kassenbuch/templates/:uuid",

    // { Bank } bank module
    bank = "/bank",
    manageBanks = "/bank/banks",
    bankOverview = "/bank/overview/:uuid",
    bankTemplates = "/bank/templates/:uuid",

    avm = "/avm",

    // { LA }
    paySlip = "/entgeltabrechnungen",
    paySlipTemplates = "/entgeltabrechnungen/templates",

    // { FE } freieerfassung
    freieErfassung = "/freieerfassung",
    freieErfassungTemplates = "/freieerfassung/templates",

    // {POS}
    pos = "/pos",
    posTemplates = "/pos/templates",

    // { Common }
    // SP4 (FIBU-22): English route per design spec §13 #16 (overrides Part
    // IV's "/kalender" - every other Common route below is German-first;
    // this one is the deliberate exception).
    calendar = "/calendar",
    SuSa = "/susa",
    BWA = "/bwa",
    UStVA = "/ustva",
    UStVAOverview = "/overview",
    UStVAExports = "/exports",
    accountsView = "/kontenauskunft",
    filtersAndSearchView = "/auswertung",
    recordImportExport = "/records",
    recordImport = "/records/import",
    recordImportAccounts = "/records/importAccounts",
    recordExport = "/records/export",
    datevConvertDocuments = "/records/belege",

    manageAccount = "/kontenverwaltung",
    manageAccountCreditors = "/kontenverwaltung/kreditor",
    manageAccountCategories = "/kontenverwaltung/kategorie",
    manageAccountTag = "/kontenverwaltung/kostenstelle",
    manageAccountDebitor = "/kontenverwaltung/debitor",
    manageAccountRecordText1Templates = "/kontenverwaltung/text1",
    manageAccountRecordText2Templates = "/kontenverwaltung/text2",
    manageAccountRules = "/kontenverwaltung/rules",
    contacts = "/contacts",

    dms = "/" + DmsPaths.ROOT,
    banks = "/" + BankingPaths.ROOT,
    invoicing = "/" + InvoicingPaths.ROOT,
    cashRegisters = "/" + CashRegisterPaths.ROOT,
}

export interface RouterParams extends Record<string, string> {
    uuid?: string;
    subGroup?: ModuleSubGroups;
}

export const getRoute = (routeTemplate: AppRoutes, params?: RouterParams): string => {
    let result: string = routeTemplate;
    if (params) {
        for (const property in params) {
            if (
                !!params[property] ||
                params[property] === "false" ||
                params[property] === "0" ||
                params[property] === ""
            ) {
                result = result.replace(`:${property}`, params[property]);
            }
        }
    }
    return result.replaceAll("//", "/");
};
